import axios from "axios"
import { 
  GET_PRE_PAYROLL,
  CLEAR_PRE_PAYROLL,
  CHANGE_PRE_PAYROLL_STATUS
} from "redux/reducers/prePayroll/prePayrollReducer.js"
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";

export const createPrePayroll = ( token, idStation, idContract, start, end, period ) => {
  const url = `${process.env.REACT_APP_URL}/crm/pre_pay_roll`
  const headers = {
    'Content-Type': 'application/json', 
    'Authorization': token 
  }

  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.post(url, {
      idStation,
      idContract,
      start,
      end,
      period
    }, { headers }).then(resp => {
      dispatch({
        type: GET_PRE_PAYROLL,
        payload: resp.data
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const getPrePayroll = ( token, status ) => {
  const url = `${process.env.REACT_APP_URL}/crm/pre_pay_roll/by_status/${status.id}`
  const headers = {
    'Content-Type': 'application/json', 
    'Authorization': token 
  }

  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.get(url, { headers }).then(resp => {
      dispatch({
        type: GET_PRE_PAYROLL,
        payload: {prePayroll: resp.data, status}
      })
    }).catch(error => {
      const err = error.response?.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const changePrePayrollStatus = ( token, status ) => {
  const url = `${process.env.REACT_APP_URL}/crm/pre_pay_roll/status/${status.id}`
  const headers = {
    'Content-Type': 'application/json', 
    'Authorization': token 
  }

  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.put(url, status, { headers }).then(resp => {
      dispatch({
        type: CHANGE_PRE_PAYROLL_STATUS,
        payload: resp.data
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const clearPrePayroll = () => {
  return {
    type: CLEAR_PRE_PAYROLL,
  }
}